/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 
 // MEMEDIA - 2 functions for cookie processing - used for redirecting to recently viewed product if user logs in/registers to view products
 function getCookie(cname) {
     var name = cname + "=";
     var decodedCookie = decodeURIComponent(document.cookie);
     var ca = decodedCookie.split(';');
     for(var i = 0; i <ca.length; i++) {
         var c = ca[i];
         while (c.charAt(0) == ' ') {
             c = c.substring(1);
         }
         if (c.indexOf(name) == 0) {
             return c.substring(name.length, c.length);
         }
     }
     return "";
 }
  function setCookie(cname, cvalue, exdays) {
     var d = new Date();
     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
     var expires = "expires="+d.toUTCString();
     document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
 }
 
 function openTab(evt, tabName, tablinks, tabcontent ) {
     // Declare all variables
     var i;

     if(tablinks === undefined){
       var tablinks = "tablinks";
     }
     if(tabcontent === undefined){
       var tabcontent = "tabcontent";
     }

     // Get all elements with class="tabcontent" and hide them
     tabcontent = document.getElementsByClassName(tabcontent);
     for (i = 0; i < tabcontent.length; i++) {
         tabcontent[i].style.display = "none";
     }
 
     // Get all elements with class="tablinks" and remove the class "active"
     tablinks = document.getElementsByClassName(tablinks);
     for (i = 0; i < tablinks.length; i++) {
         tablinks[i].className = tablinks[i].className.replace(" active", "");
     }
 
     // Show the current tab, and add an "active" class to the button that opened the tab
     document.getElementById(tabName).style.display = "block";
     evt.currentTarget.className += " active";
 }
 
 // When the user scrolls down 20px from the top of the document, show the button
 window.onscroll = function() {scrollFunction()};
 
 function scrollFunction() {
   if(document.getElementById("myBtn")){
     if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
         //document.getElementById("myBtn").style.display = "block";
     } else {
         document.getElementById("myBtn").style.display = "none";
     }
   }
 }
 
 // When the user clicks on the button, scroll to the top of the document
 function topFunction() {
     document.body.scrollTop = 0;
     document.documentElement.scrollTop = 0;
 }
 
 var links = document.links;
 for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
   if (links[i].hostname !== window.location.hostname) {
     links[i].target = '_blank';
     links[i].relList.add('noreferrer', 'noopener');
   }
 }
 window.onload = function() {
     let touchingCarousel = false,
       touchStartCoords;
 
     document.body.addEventListener('touchstart', function(e) {
       if (e.target.closest('.flickity-slider')) {
         touchingCarousel = true;
       } else {
         touchingCarousel = false;
         return;
       }
 
       touchStartCoords = {
         x: e.touches[0].pageX,
         y: e.touches[0].pageY
       }
     });
 
     document.body.addEventListener('touchmove', function(e) {
       if (!(touchingCarousel && e.cancelable)) {
         return;
       }
 
       let moveVector = {
         x: e.touches[0].pageX - touchStartCoords.x,
         y: e.touches[0].pageY - touchStartCoords.y
       };
 
       if (Math.abs(moveVector.x) > 7)
         e.preventDefault()
 
     }, {passive: false});
   
       
       /* MeMedia adding in Podium callback 
         - we need to assign this to a google event
         - this is already being recorded in analytics under the goals
         - hiding for possible future use
       window.PodiumEventsCallback = function(e, properties) {
       if(e == ''){
           ga(‘send’, ‘event’, ‘Category’, ‘Action’, ‘Label’, ‘Value’);
       }
         console.log('Got event', e);
         console.log('Got properties', properties);
     };
     */
 
 }; 
 
 /* 
 MeMedia - added func to show/hide element by its ID 
 Usage.. (display:none; to start off hidden)
 <a href="#' onclick="showHideID('elemetid', 'fa-caret-down', 'fa-caret-up')">Show/Hide <i class="fa fa-caret-down"></i></a>
 <div id="elementid" style="display:none;">content to show/hide</div>
 
 function showHideID(divid, downarrow, uparrow) {
   var x = document.getElementById(divid);
   if (x.style.display === "none") {
     x.style.display = "block";
     if($this.)
   } else {
     x.style.display = "none";
   }
 }
 */
 function showHideID(e, button, divid, uparrow, downarrow){
     e.preventDefault();
     icon = $(button).find('.fa');
   
     $('#'+divid).slideToggle('500', function(){
         if ($('#'+divid).is(':hidden')){
             icon.removeClass(downarrow).addClass(uparrow);
         } else {
             icon.removeClass(uparrow).addClass(downarrow);
         }
     });
 }